import { render } from "./BottomSheet.vue?vue&type=template&id=2aae30f6&scoped=true"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"

import "./BottomSheet.vue?vue&type=style&index=0&id=2aae30f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aae30f6"]])

export default __exports__